// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post('/auth/staff/forgot-password', { email: email.trim() });
      setSent(true);
    } catch (err) {
      // Backend always returns 200 — treat any error as success too (no leaking)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '2rem', color: 'white', marginBottom: 6 }}>NJJBA</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', letterSpacing: '1px', textTransform: 'uppercase' }}>
            Chamber Management
          </p>
        </div>

        <div className="card" style={{ padding: '32px 36px' }}>
          {!sent ? (
            <>
              <h2 style={{ marginBottom: 8, color: 'var(--navy)', fontFamily: 'var(--font-serif)' }}>Reset Password</h2>
              <p style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginBottom: 20 }}>
                Enter your staff email and we'll send you a link to set a new password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@njjba.com"
                    autoFocus
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-full btn-lg" disabled={loading} style={{ marginTop: 8, justifyContent: 'center' }}>
                  {loading ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Sending...</> : 'Send Reset Link'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                <Link to="/login" style={{ fontSize: '0.85rem', color: 'var(--gray-500)', textDecoration: 'none' }}>
                  ← Back to sign in
                </Link>
              </div>
            </>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: 16, fontSize: '3rem' }}>📧</div>
              <h2 style={{ marginBottom: 12, color: 'var(--navy)', fontFamily: 'var(--font-serif)', textAlign: 'center' }}>Check your email</h2>
              <p style={{ fontSize: '0.9rem', color: 'var(--gray-600)', textAlign: 'center', marginBottom: 4 }}>
                If an account with that email exists, a password reset link has been sent.
              </p>
              <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', textAlign: 'center', marginBottom: 20 }}>
                The link expires in 1 hour.
              </p>
              <Link to="/login" className="btn btn-secondary w-full" style={{ justifyContent: 'center' }}>
                Back to Sign In
              </Link>
            </>
          )}
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '0.75rem', marginTop: 24 }}>
          New Jersey Jewish Business Alliance · portal.njjba.com
        </p>
      </div>
    </div>
  );
}
